"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const valueIsArray_1 = __importDefault(require("../typeAssertions/valueIsArray"));
const valueIsNotUndefined_1 = __importDefault(require("../typeAssertions/valueIsNotUndefined"));
const valueIsString_1 = __importDefault(require("../typeAssertions/valueIsString"));
const getValueByPathFromUnknown_1 = __importDefault(require("./getValueByPathFromUnknown"));
const googleMapsDecodePolylineString_1 = __importDefault(require("./googleMapsDecodePolylineString"));
const getPolilineFromStep = (step) => {
    const polilineStringRaw = (0, getValueByPathFromUnknown_1.default)(step, ['polyline', 'points']);
    if (!(0, valueIsString_1.default)(polilineStringRaw)) {
        return undefined;
    }
    return polilineStringRaw;
};
const googleMapsGetPathCoordinatesFromApiResponse = (responseData) => {
    const rawRoute = (0, getValueByPathFromUnknown_1.default)(responseData, ['routes', 0]);
    const rawSteps = (0, getValueByPathFromUnknown_1.default)(rawRoute, ['legs', 0, 'steps']);
    if (!(0, valueIsArray_1.default)(rawSteps)) {
        const rawOverviewPolyline = (0, getValueByPathFromUnknown_1.default)(rawRoute, ['overview_polyline', 'points']);
        if ((0, valueIsString_1.default)(rawOverviewPolyline)) {
            return (0, googleMapsDecodePolylineString_1.default)(rawOverviewPolyline);
        }
        return [];
    }
    return rawSteps
        .map(getPolilineFromStep)
        .filter(valueIsNotUndefined_1.default)
        .map(googleMapsDecodePolylineString_1.default)
        .reduce((accum, list) => [
        ...accum,
        ...list,
    ], []);
};
exports.default = googleMapsGetPathCoordinatesFromApiResponse;
